import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from './firebase';
export function subscribeByIds(name, field, ids, onData, onError) {
    const unique = [...new Set(ids || [])];
    if (!unique.length) { onData([]); return () => {}; }
    const buckets = [];
    const unsubscribers = [];
    try {
        for (let i = 0; i < unique.length; i += 30) {
            const index = i / 30;
            unsubscribers.push(onSnapshot(query(collection(db, name), where(field, 'in', unique.slice(i, i + 30))), snap => {
                buckets[index] = snap.docs.map(item => ({ ...item.data(), id: item.id }));
                onData(buckets.flat());
            }, onError));
        }
    } catch (error) { unsubscribers.forEach(stop => stop()); onError?.(error); }
    return () => unsubscribers.forEach(stop => stop());
}
